const EmailConstants = {
  GET_EMAIL_DISTRIBUTION_GROUP_SUCCESS: "GET_EMAIL_DISTRIBUTION_GROUP_SUCCESS",
  GET_EMAIL_DISTRIBUTION_GROUP_FAILURE: "GET_EMAIL_DISTRIBUTION_GROUP_FAILURE",
  ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_SUCCESS:
    "ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_SUCCESS",
  ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_FAILURE:
    "ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_FAILURE",
  GET_EQIPMENT_FILTER_SUCCESS: "GET_EQIPMENT_FILTER_SUCCESS",
  GET_EQIPMENT_FILTER_FAILURE: "GET_EQIPMENT_FILTER_FAILURE",
  SAVE_OR_UPDATE_EMAIL_SCHEDULE_SUCCESS:
    "SAVE_OR_UPDATE_EMAIL_SCHEDULE_SUCCESS",
  SAVE_OR_UPDATE_EMAIL_SCHEDULE_FAILURE:
    "SAVE_OR_UPDATE_EMAIL_SCHEDULE_FAILURE",
  GET_SCHEDULE_EMAIL_SUCCESS: "GET_SCHEDULE_EMAIL_SUCCESS",
  GET_SCHEDULE_EMAIL_FAILURE: "GET_SCHEDULE_EMAIL_FAILURE",
  REPLACE_EMAIL_SUCCESS: "REPLACE_EMAIL_SUCCESS",
  REPLACE_EMAIL_FAILURE: "REPLACE_EMAIL_FAILURE",
  DELETE_SCHEDULE_EMAIL_SUCCESS: "DELETE_SCHEDULE_EMAIL_SUCCESS",
  DELETE_SCHEDULE_EMAIL_FAILURE: "DELETE_SCHEDULE_EMAIL_FAILURE",
  // GET_SCHEDULE_EMAIL_BYID_SUCCESS: "GET_SCHEDULE_EMAIL_BYID_SUCCESS",
  // GET_SCHEDULE_EMAIL_BYID_FAILURE: "GET_SCHEDULE_EMAIL_BYID_FAILURE",
  GET_SCHEDULE_EMAIL_ATTACHMENT_SUCCESS:
    "GET_SCHEDULE_EMAIL_ATTACHMENT_SUCCESS",
  GET_SCHEDULE_EMAIL_ATTACHMENT_FAILURE:
    "GET_SCHEDULE_EMAIL_ATTACHMENT_FAILURE",
};

export default EmailConstants;
